import request from '@/request'

const dict = {
  namespaced: true,
  state: {},
  /**
   * getter是state的计算属性
   *
   * getter原型
   * export type Getter<S, R> = (state: S, getters: any, rootState: R, rootGetters: any) => any;
   */
  getters: {
    getDict: (state) => (dictType, sort) => {
      return state[dictType + sort]
    }
  },
  /**
   * mutation类似redux中的reducer
   *
   * mutation原型：
   * export type Mutation<S> = (state: S, payload?: any) => any;
   */
  mutations: {
    UPDATE_DICT(state, {
      dictType,
      sort,
      data
    }) {
      Object.assign(state, {
        [dictType + sort]: data
      })
    }
  },
  /**
   * action类似redux中的effect
   *
   * action原型：
   * export type Action<S, R> = ActionHandler<S, R> | ActionObject<S, R>;
   * export type ActionHandler<S, R> = (this: Store<R>, injectee: ActionContext<S, R>, payload?: any) => any;
   * export interface ActionContext<S, R> {
   *   dispatch: Dispatch;
   *   commit: Commit;
   *   state: S;
   *   getters: any;
   *   rootState: R;
   *   rootGetters: any;
   * }
   * export interface ActionObject<S, R> {
   *   root?: boolean;
   *   handler: ActionHandler<S, R>;
   * }
   */
  actions: {
    fetchDict({
      commit,
      state
    }, payload) {
      const {
        dictType,
        sort
      } = payload
      if (dictType && !state[dictType + sort]) {
        getDictDropdown(dictType, sort).then((data) => {
          commit('UPDATE_DICT', {
            dictType,
            sort,
            data: data.data
            // data
          })
        })
      }
    },
    fetchDictForce({
      commit
    }, payload) {
      const {
        dictType,
        sort
      } = payload
      if (dictType) {
        getDictDropdown(dictType, sort).then((data) => {
          commit('UPDATE_DICT', {
            dictType,
            sort,
            data
          })
        })
      }
    }
  }
}

async function getDictDropdown(type, sort = 'asc') {
  return request
    // .get(`/api/sys/v1/sys/dicts/types/${type}/dropdown`)
    .get(`/api/sys/v1/sys/dicts/types/${type}/dropdown?sort=${sort}`)
    .then((response) => response.data)
}

export default dict